var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"lang-switcher"},_vm._l((_vm.available),function(locale,index){return _c('li',{key:index},[_c('nuxt-link',{attrs:{"to":locale.link}},[_vm._v("\n        "+_vm._s(locale.title)+"\n      ")])],1)}),0),_vm._v("\n  "+_vm._s(_vm.current)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }